/**
 * Ouverture des pages Stripe (Connect onboarding, Checkout, espace Express).
 *
 * Stripe interdit l'affichage de ses pages dans une iframe (en-tête CSP `frame-ancestors`
 * limité à *.stripe.com). Si MIHOD PAY est lui-même affiché dans une iframe (aperçu, intégration
 * dans un autre site), `window.location.href = url` navigue DANS l'iframe et le navigateur affiche
 * « connect.stripe.com n'autorise pas la connexion ». On ouvre alors Stripe au premier niveau :
 * nouvel onglet (réservé de façon synchrone au clic pour éviter les bloqueurs de popup), sinon
 * fenêtre parente. Hors iframe (onglet normal, PWA installée, application native), redirection
 * classique dans la même fenêtre.
 */

export const isEmbedded = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true; // accès cross-origin refusé => on est bien dans une iframe
  }
};

/**
 * À appeler DE FAÇON SYNCHRONE dans le gestionnaire de clic, AVANT tout appel réseau :
 * réserve l'onglet cible quand on est dans une iframe (sinon rien).
 */
export const prepareExternal = () => {
  if (!isEmbedded()) return null;
  try {
    const w = window.open("", "_blank");
    if (w) {
      try {
        w.opener = null;
        w.document.write(
          '<!doctype html><title>MIHOD PAY → Stripe</title>' +
          '<body style="font-family:sans-serif;display:grid;place-items:center;height:100vh;margin:0;background:#0b0b0c;color:#eee">' +
          '<p>Ouverture de la page sécurisée Stripe…</p></body>'
        );
      } catch (e) {}
    }
    return w;
  } catch (e) {
    return null;
  }
};

/**
 * Navigue vers `url` (page Stripe) en respectant le contexte.
 * @param {string} url            URL Stripe (https://connect.stripe.com/…, https://checkout.stripe.com/…)
 * @param {Window|null} reserved  onglet réservé par prepareExternal() (peut être null)
 * @returns {"same"|"tab"|"top"}  mode utilisé
 */
export const openExternal = (url, reserved = null) => {
  if (!url) return "same";
  if (!isEmbedded()) {
    window.location.href = url;
    return "same";
  }
  if (reserved && !reserved.closed) {
    reserved.location.href = url;
    try { reserved.focus(); } catch (e) {}
    return "tab";
  }
  const w = window.open(url, "_blank", "noopener,noreferrer");
  if (w) return "tab";
  try {
    window.top.location.href = url; // même origine : on sort de l'iframe
    return "top";
  } catch (e) {
    window.location.href = url; // dernier recours
    return "same";
  }
};

/** Ferme un onglet réservé si l'appel API a échoué (évite un onglet vide). */
export const cancelExternal = (reserved) => {
  try { if (reserved && !reserved.closed) reserved.close(); } catch (e) {}
};
